export default "__VITE_ASSET__ac1377b8__"